import React from "react";
import { Spin } from "antd";

const Spinner = () => {
  return (
    <>
      <div
        className="d-flex justify-content-center"
        style={{ height: "100vh" }}
      >
        <Spin
          className="d-flex align-items-center"
          size="large"
          style={{ height: "100%" }}
        ></Spin>
      </div>
    </>
  );
};

export default Spinner;
